/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';

// redux
import { useDispatch, useSelector } from "react-redux";
import {fetchHistoricalData} from "../../../../../state/thunks/account";
import {resetHistoricalDownloadStatus} from "../../../../../state/slices/account";

// material
import { Button } from '@insticator/insticator-ui';
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import SectionGroupDescription
  from "../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";
import SectionCard from "../../../../../material/expandablesection/sectioncard/sectioncard";
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";

// styles
import injectSheet from 'react-jss';
import styles from './historical_styles';

// const
const HISTORICAL_DESCRIPTION = 'The downloaded CSV file will contain all historical monetization data and metrics from ' +
  'our other decommissioned platforms. The file will contain all metrics for the specified date below rolled-up on a daily basis.'

/* ========== ~~~~~~~~~~ ADVANCED CONFIG - SENTIMENT ~~~~~~~~~~ ========== */
const HistoricalData = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const accountUUID = useSelector((state) => state.session.accountUUID)
  const initialHistoricalRevenue = useSelector((state) => state.account.accountSettings.initialHistoricalRevenue)
  const finalHistoricalRevenue = useSelector((state) => state.account.accountSettings.finalHistoricalRevenue)
  const downloadStatus = useSelector((state) => state.account.historicalDownloadStatus)
  const formattedInitialHistoricalRevenue = new Intl.DateTimeFormat('en-GB', { dateStyle: 'long'}).format(new Date(initialHistoricalRevenue))
  const formattedFinalHistoricalRevenue = new Intl.DateTimeFormat('en-GB', { dateStyle: 'long'}).format(new Date(finalHistoricalRevenue))

  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (downloadStatus === 'success' || downloadStatus === 'error') setTimeout(() => {
      dispatch(resetHistoricalDownloadStatus())
    }, 2000);
  }, [downloadStatus])

  const getDaysDifference = () => {
    const oneDay = 24 * 60 * 60 * 1000
    return Math.round(Math.abs((new Date(finalHistoricalRevenue) - new Date(initialHistoricalRevenue)) / oneDay))
  }

  const handleToggle = () => {
    setIsOpened(!isOpened)
  };

  const handleCancel = () => {
    setIsOpened(false)
  };

  const handleDownload = () => {
    if (!accountUUID) return
    dispatch(fetchHistoricalData(accountUUID))
  };

  const getIcon = () => {
    if (downloadStatus === 'success') return 'check'
    if (downloadStatus === 'pending') return 'arrow-down'
    if (downloadStatus === 'error') return 'exclamation'
    return 'download'
  }

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      isOpened={isOpened}
      title='Historical Data'
      configTitle={'View'}
      cancelTitle={'Close'}
    />
  );

  return (
    <ExpandableSection
      className={`historical ${props.classes.historical}`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleCancel}
      cancelTitle={'Close'}
    >
      <SectionCard>
        <SectionGroup>
          <SectionGroupDescription
            title={'Download Historical Data'}
            description={HISTORICAL_DESCRIPTION}
            descriptionClassName={'descriptionWidth'}
          />

          <br />

          <div>
            {initialHistoricalRevenue == null || finalHistoricalRevenue == null
              ? "Click download button to generate historical data"
              : `${formattedInitialHistoricalRevenue} - ${formattedFinalHistoricalRevenue} (${getDaysDifference()} days)`}
            <Button text={'Download'}
                    icon={getIcon()}
                    variant={'none'}
                    klass={'btnDownload'}
                    handleClick={handleDownload}
            />
          </div>
        </SectionGroup>
      </SectionCard>
    </ExpandableSection>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HistoricalData;
